// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-container {
  display: flex;
  height: 4.5rem; /* 72px */
  padding: 1rem 1.5rem; /* 16px 24px */
  align-items: center;
  gap: 0.5rem; /* 8px */
  align-self: stretch;
  border: 1px solid var(--Neutral-Neutral-300, #D1D5DB);
  background: var(--Neutral-100, #F1F5F9);
  width: 100%;
 
}

.Header-content-wrapper {
  display: flex;
  align-items: center;
  gap: 0.375rem; /* 6px */
  flex: 1 0;
  max-width: 56.5rem; /* 904px */
}

.Header-text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem; /* 4px */
}

.Header-backbutton-wrapper {
  display: flex;
  width: 2rem; /* 32px */
  height: 2rem; /* 32px */
  padding: 0rem 0.625rem 0rem 0.5625rem; /* 0px 10px 0px 9px */
  justify-content: center;
  align-items: center;
}

.Header-backbutton {
  color: #020618;
  text-align: center;
  font-family: "Font Awesome 6 Pro";
  font-size: 1.25rem; /* 20px */
  font-style: normal;
  font-weight: 400;
  line-height: 2.5rem; /* 40px */
  letter-spacing: 0px;
  cursor: pointer;
}

.Header-title {
  display: flex;
  height: 1.5rem; /* 24px */
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  color: var(--Neutral-950, #020618);
  font-family: Inter;
  font-size: 1rem; /* 16px */
  font-style: normal;
  font-weight: 600;
  line-height: 1.5rem; /* 24px */
  letter-spacing: 0.03125rem; /* 0.5px */
}

.Header-subtitle {
  align-self: stretch;
  color: var(--Neutral-600, #475569);
  font-family: Inter;
  font-size: 0.75rem; /* 12px */
  font-style: normal;
  font-weight: 400;
  line-height: 1rem; /* 16px */
  letter-spacing: 0.03125rem; /* 0.5px */
}


@media(max-width:480px){
  .Header-title{
    font-size:14px;
  }
  .Header-subtitle{
    font-size:10px;
  }
  .Header-text-wrapper{
    gap: 0.05rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Header-Assesment/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc,EAAE,SAAS;EACzB,oBAAoB,EAAE,cAAc;EACpC,mBAAmB;EACnB,WAAW,EAAE,QAAQ;EACrB,mBAAmB;EACnB,qDAAqD;EACrD,uCAAuC;EACvC,WAAW;;AAEb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa,EAAE,QAAQ;EACvB,SAAW;EACX,kBAAkB,EAAE,UAAU;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY,EAAE,QAAQ;AACxB;;AAEA;EACE,aAAa;EACb,WAAW,EAAE,SAAS;EACtB,YAAY,EAAE,SAAS;EACvB,qCAAqC,EAAE,qBAAqB;EAC5D,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc,EAAE,SAAS;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,eAAe,EAAE,SAAS;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;EAC9B,0BAA0B,EAAE,UAAU;AACxC;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB,EAAE,SAAS;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,0BAA0B,EAAE,UAAU;AACxC;;;AAGA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".Header-container {\n  display: flex;\n  height: 4.5rem; /* 72px */\n  padding: 1rem 1.5rem; /* 16px 24px */\n  align-items: center;\n  gap: 0.5rem; /* 8px */\n  align-self: stretch;\n  border: 1px solid var(--Neutral-Neutral-300, #D1D5DB);\n  background: var(--Neutral-100, #F1F5F9);\n  width: 100%;\n \n}\n\n.Header-content-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem; /* 6px */\n  flex: 1 0 0;\n  max-width: 56.5rem; /* 904px */\n}\n\n.Header-text-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem; /* 4px */\n}\n\n.Header-backbutton-wrapper {\n  display: flex;\n  width: 2rem; /* 32px */\n  height: 2rem; /* 32px */\n  padding: 0rem 0.625rem 0rem 0.5625rem; /* 0px 10px 0px 9px */\n  justify-content: center;\n  align-items: center;\n}\n\n.Header-backbutton {\n  color: #020618;\n  text-align: center;\n  font-family: \"Font Awesome 6 Pro\";\n  font-size: 1.25rem; /* 20px */\n  font-style: normal;\n  font-weight: 400;\n  line-height: 2.5rem; /* 40px */\n  letter-spacing: 0px;\n  cursor: pointer;\n}\n\n.Header-title {\n  display: flex;\n  height: 1.5rem; /* 24px */\n  flex-direction: column;\n  justify-content: center;\n  align-self: stretch;\n  color: var(--Neutral-950, #020618);\n  font-family: Inter;\n  font-size: 1rem; /* 16px */\n  font-style: normal;\n  font-weight: 600;\n  line-height: 1.5rem; /* 24px */\n  letter-spacing: 0.03125rem; /* 0.5px */\n}\n\n.Header-subtitle {\n  align-self: stretch;\n  color: var(--Neutral-600, #475569);\n  font-family: Inter;\n  font-size: 0.75rem; /* 12px */\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1rem; /* 16px */\n  letter-spacing: 0.03125rem; /* 0.5px */\n}\n\n\n@media(max-width:480px){\n  .Header-title{\n    font-size:14px;\n  }\n  .Header-subtitle{\n    font-size:10px;\n  }\n  .Header-text-wrapper{\n    gap: 0.05rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
